import { useEffect, useRef } from "react";
import { Ad } from "../types";

export const useAds = (
  callKrpano: (action: string) => void,
  setKrpano: (action: string, value: any) => void,
  ads: Ad[]
) => {
  const prevIds = useRef<string[]>([]);

  useEffect(() => {
    // Remove previous ad hotspots
    prevIds.current.forEach((id) => {
      callKrpano(`removehotspot(ad_${id})`);
    });

    // Add new ad hotspots
    ads.forEach((ad) => {
      if (!ad.imageUrl) return;
      const hsName = `ad_${ad.id}`;
      callKrpano(`addhotspot(${hsName})`);
      setKrpano(`hotspot[${hsName}].url`, ad.imageUrl);
      setKrpano(`hotspot[${hsName}].ath`, ad.ath);
      setKrpano(`hotspot[${hsName}].atv`, ad.atv);
      setKrpano(`hotspot[${hsName}].width`, `${ad.width}`);
      setKrpano(`hotspot[${hsName}].height`, `${ad.height}`);
      setKrpano(`hotspot[${hsName}].distorted`, "true");

      if (ad.link) {
        setKrpano(
          `hotspot[${hsName}].onclick`,
          `openurl('${ad.link}', '_blank')`
        );
      }
    });

    prevIds.current = ads.map((a) => a.id);
  }, [ads, callKrpano, setKrpano]);
};
